import React from 'react'
import updateShouldUpdateMediaAction from 'modules/media-gallery/redux/actions/update-should-update-media'
import updateSelectedColorVariantIdVariantAction from 'modules/variant/redux/actions/update-selected-color-variant-id'
import addSelectedVariantIdToUrlProductUtil from 'modules/product/utils/add-selected-variant-id-to-url'
import runAfterDelayTimingUtil from 'utils/timing/run-after-delay'
import useDispatch from 'hooks/use-dispatch'

const QuickShopLoadRatedVariant = ({ ratedVariantId }) => {
  const dispatch = useDispatch()

  React.useEffect(() => {
    if (!ratedVariantId) {
      return
    }

    dispatch(
      updateShouldUpdateMediaAction(false)
    )

    dispatch(
      updateSelectedColorVariantIdVariantAction({
        variantId: ratedVariantId,
        shouldAddToUrl: false,
        fromSidebar: true,
        updateMediaGallery: true,
        caller: 'QuickShopLoadRatedVariant'
      })
    )

    addSelectedVariantIdToUrlProductUtil({
      selectedVariantId: ratedVariantId
    })

    runAfterDelayTimingUtil(1500, () => {
      dispatch(
        updateShouldUpdateMediaAction(true)
      )
    })
  }, [ratedVariantId])

  return <></>
}

export default QuickShopLoadRatedVariant
